/** Calendar content (or its card) as the card and the frame draw it. */
import { formatDate } from "@/i18n";
import { toAgendaItems } from "@/components/shapes/agenda-frame/agenda-items";
import { plainColor } from "@/components/shapes/shared/card-tint";
import type { CardEventRow } from "@/components/shapes/shared/card-visual-parts";

/** Each event's own colour, by id, when it is a plain colour. */
function eventColors(value: unknown): Map<string, string> {
  const colors = new Map<string, string>();
  if (!Array.isArray(value)) return colors;
  for (const raw of value) {
    if (typeof raw !== "object" || raw === null) continue;
    const row = raw as Record<string, unknown>;
    const color = plainColor(row.color);
    if (typeof row.id === "string" && color) colors.set(row.id, color);
  }
  return colors;
}

/** The events of `value` as rows, each in its own colour when it names one. */
export function calendarRows(value: unknown): CardEventRow[] {
  const colors = eventColors(value);
  return (toAgendaItems(value) ?? []).map((event) => ({
    ...event,
    color: colors.get(event.id),
  }));
}

/** `date`'s short weekday in the app locale (the accent and the week strip). */
export function weekdayLabel(date: Date): string {
  return formatDate(date, { weekday: "short" });
}

/** Today as `DayAccent` shows it: the day number and short weekday. */
export function todayAccent(now: Date = new Date()) {
  return {
    day: String(now.getDate()),
    weekday: weekdayLabel(now).toUpperCase(),
    label: null,
  };
}
